import React, { useEffect, useState } from "react";
import CrmLayout from "../../components/CrmLayout";
import api from "../../lib/api";
import { Badge } from "../../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Mail, MessageSquare, CheckCircle2, XCircle } from "lucide-react";

const KIND = { confirmation: "Confirmation", reminder: "Reminder", followup: "Follow-up" };

export default function Messages() {
  const [data, setData] = useState({ items: [], sms_configured: false, email_configured: false, sms_available: false });
  useEffect(() => { api.get("/notifications").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <CrmLayout title="Messages">
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <Channel icon={Mail} label="Email reminders" on={data.email_configured} note="Ready — sent automatically via Booking Babe." />
        <Channel icon={MessageSquare} label="SMS reminders" on={data.sms_configured}
          note={!data.sms_available ? "Upgrade to Professional to unlock SMS." : data.sms_configured ? "Active — using your Twilio account." : "Add your Twilio keys in Settings to enable SMS."} />
      </div>
      <div className="bg-card border border-border rounded-lg overflow-hidden">
        <div className="px-5 py-4 border-b border-border"><h2 className="font-semibold">Message log</h2><p className="text-xs text-muted-foreground">Confirmations, reminders and follow-ups.</p></div>
        <Table>
          <TableHeader><TableRow><TableHead>Type</TableHead><TableHead>Client</TableHead><TableHead>Email</TableHead><TableHead>SMS</TableHead><TableHead>When</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.items.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10">No messages sent yet.</TableCell></TableRow>}
            {data.items.map((n) => (
              <TableRow key={n.id} data-testid={`msg-${n.id}`}>
                <TableCell><Badge className="bg-secondary text-secondary-foreground">{KIND[n.kind] || n.kind}</Badge></TableCell>
                <TableCell className="text-sm">{n.client_name}</TableCell>
                <TableCell>{n.email_sent ? <CheckCircle2 size={16} className="text-[hsl(var(--success))]" /> : <XCircle size={16} className="text-muted-foreground/40" />}</TableCell>
                <TableCell>{n.sms_sent ? <CheckCircle2 size={16} className="text-[hsl(var(--success))]" /> : <XCircle size={16} className="text-muted-foreground/40" />}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{new Date(n.created_at).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </CrmLayout>
  );
}

function Channel({ icon: Icon, label, on, note }) {
  return (
    <div className="bg-card border border-border rounded-lg p-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3"><div className="w-10 h-10 rounded-md bg-primary/10 flex items-center justify-center text-primary"><Icon size={18} /></div><span className="font-medium">{label}</span></div>
        <Badge className={on ? "bg-[hsl(var(--success))]/15 text-[hsl(var(--success))]" : "bg-muted text-muted-foreground"}>{on ? "Active" : "Off"}</Badge>
      </div>
      <p className="text-sm text-muted-foreground mt-3">{note}</p>
    </div>
  );
}
